module.exports = __webpack_public_path__ + "img/Flag_of_Vanuatu.f0b65910.svg";